import { Component } from '@angular/core';
import { ViewController, Platform } from 'ionic-angular';
import { AppData } from '../../providers/app-data';
import { StorageService } from '../../services/storage-service';
import { SavedLocation } from '../../classes/SavedLocation';

@Component({
    selector: 'location-list',
    templateUrl: 'location-list.component.html'
})
export class LocationList {
    private storageKey: string = this.appData.settings.locationStorageKey;
    private storageHelper: StorageService = new StorageService();
    public savedLocations: SavedLocation[] = []

    constructor(public viewCtrl: ViewController, private appData: AppData, private platform: Platform) {

    }

    ngOnInit() { 
        this.reload();
    }

    reload() {
        //load saved locations from local storage into the array for display
        let recievedVals = this.storageHelper.get<SavedLocation[]>(this.storageKey)
        if (recievedVals) {
            this.savedLocations = recievedVals;
        } else {
            this.savedLocations = []
        }
    }

    openMapsApp(lat: number, lon: number) {
        if (this.platform.is('android')) {
            window.open(`geo:0,0?q=${lat},${lon}`, '_system');
        } else if (this.platform.is('ios')) {
            window.open(`maps://?q=${lat},${lon}`, '_system');
        } else {
            window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${lon}`, '_blank');
        }
    }

    remove(index: number) {
        this.savedLocations.splice(index,1);
        this.storageHelper.set(this.storageKey, this.savedLocations);
    }

    dismiss(data?: any) {
        // using the injected ViewController this page
        // can "dismiss" itself and pass back data
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/location-list/location-list.component.ts